import { render, staticRenderFns } from "./InviteAdministratorsComponent.vue?vue&type=template&id=22730474&scoped=true"
import script from "./InviteAdministratorsComponent.vue?vue&type=script&lang=js"
export * from "./InviteAdministratorsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22730474",
  null
  
)

export default component.exports